import Vue from 'vue';
import VueQuillEditor, { Quill } from 'vue-quill-editor';
import mention from 'quill-mention';
import maxLengthModule from '../components/text-editors/max-length-module';
import { fonts, sizes } from '../components/text-editors/fonts';

Quill.register('modules/mention ', mention);
Quill.register('modules/maxlength', maxLengthModule);
Quill.register(fonts, true);
Quill.register(sizes, true);

Vue.use(VueQuillEditor);
